<template>
  <div>
    <v-file-input
      id="fileInput"
      hide-input
      :accept="accept"
      class="d-none"
      @click="loading = false"
      @change="onFileSelect"
    />

    <slot name="element" :onClick="selectFile" :loading="loading"></slot>

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "FileSelector",
  props: {
    accept: String,
  },
  data() {
    return {
      loading: false,
      snackbarError: false,
      snackbarErrorMessage: null,
    };
  },
  methods: {
    selectFile() {
      document.getElementById("fileInput").click();
    },
    onFileSelect(file) {
      if (this.accept.includes(file.type)) {
        this.$emit("onFileSelect", {
          blob: file,
          dataUrl: window.URL.createObjectURL(file),
        });

        // const reader = new FileReader();
        // reader.readAsDataURL(file);
        //
        // reader.onloadend = () => {
        //   this.loading = false;
        //
        //   this.$emit("onFileSelect", {
        //     blob: file,
        //     dataUrl: reader.result,
        //   });
        // };
      } else {
        this.snackbarError = true;
        this.snackbarErrorMessage = this.$t("unsupportedFileFormat");
      }
    },
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
  },
};
</script>

<style lang="scss" scoped />
